export * from './pdf-viewer.module';
export * from './pdf-viewer.component';
